/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusNewsletterSendResultDto } from '../../models/lexplus-newsletter-send-result-dto';
import { LexplusSendNewsletterDto } from '../../models/lexplus-send-newsletter-dto';

export interface NewsletterVersandControllerSendV1$Params {
      body: LexplusSendNewsletterDto
}

export function newsletterVersandControllerSendV1(http: HttpClient, rootUrl: string, params: NewsletterVersandControllerSendV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusNewsletterSendResultDto>> {
  const rb = new RequestBuilder(rootUrl, newsletterVersandControllerSendV1.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusNewsletterSendResultDto>;
    })
  );
}

newsletterVersandControllerSendV1.PATH = '/v1/newsletter-versand';
